export class AnimalSampleOrder {
    _id: string;
    labId: string;
    barcode: string;
    reused:boolean;
    order: Array<string>;
    tests: Array<SampleTest>;
    dna: SampleDNA;
    createdBy: string;
    lastModifiedBy: string;
    creationDate: Date;
    lastModifiedDate: Date;
    version: number;
}

export class SampleTest {
    code: string;
}

export class SampleDNA {
    dog?: SampleDNAType;
    father?: SampleDNAType;
    mother?: SampleDNAType;
}

export class SampleDNAType {
    id: string;
    isagSNP?: SampleDNATypeOrder;
    isagSTR?: SampleDNATypeOrder;
}

export class SampleDNATypeOrder {
    panel?: string
    markers?: Array<SampleDNAOrderMarker>;
}

export class SampleDNAOrderMarker {
    markerName?: string;
    value?: string;
}

export enum SampleStatus {
    WAITING = 'WAITING',
    RECEIVED = 'RECEIVED',
    PROBLEM = 'PROBLEM',
    ADDITIONAL = 'ADDITIONAL',
    EMPTY = 'EMPTY',
    DATA_ONLY = 'DATA_ONLY',
    MISSING = 'MISSING',
    TEST_ERROR = 'TEST_ERROR'
}

export enum SampleOrderType {
    TEST = 'TEST',
    SNP = 'SNP',
    STR = 'STR',
    STRP = 'STR-P',
    SNPP = 'SNP-P'
}